import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants/'
import { atom, selector } from 'recoil'

export const messageState = atom({
  key: 'messageCheckupSummaryMessageState',
  default: {
    id: undefined,
    messageType: undefined,
    isBee: undefined,
    checkup: {}
  }
})

export const canSendState = selector({
  key: 'messageCheckupSummaryCanSendState',
  get: ({ get }) => {
    const { messageType } = get(messageState)

    return messageType && messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN
  }
})

export const canCodeReviewState = selector({
  key: 'messageCheckupSummaryCanCodeReviewState',
  get: ({ get }) => {
    const { id, isBee } = get(messageState)

    return id && !isBee
  }
})

export const mdCheckup = atom({
  key: 'overviewMdCheckup',
  default: {
    dynamicFieldsOptionEnabled: false,
    wrongDynamicTags: [],
    checkLiquidCode: true,
    checkAttachments: true,
    checkDynamicContents: true,
    checkSize: true,
    checkBlacklistResult: true,
    checkContent: true,
    checkLinksWoTracking: true,
    checkUnsubscribeLink: true,
    checkMaxSize: true,
    checkPreheader: true,
    checkWebAnalytics: true,
    checkWorkflowWarning: false,
    addToWhiteList: [],
    silencedAlertsArray: [],
    workflowsEntities: []
  }
})

export const modalNoEdit = atom({
  key: 'checkupSummaryModalNoEdit',
  default: false
})
